import LayoutContentArea from "@/components/layout/LayoutContentArea";
import { CalpadsSyncLookupView } from "@/components/records/calpads-sync/CalpadsSyncLookupView";

export default function CalpadsSyncLookupPage() {
  return (
    <LayoutContentArea headingText="CALPADS Sync Lookup">
      <CalpadsSyncLookupView />
    </LayoutContentArea>
  );
}
